import { render, staticRenderFns } from "./ThemesEditorNavSection.vue?vue&type=template&id=352d0905"
import script from "./ThemesEditorNavSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorNavSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports